import React from "react";
import {Line} from "../Line";

export type PointerProps = {
    color?: string;
};

export const Pointer = (props: JSX.IntrinsicElements['mesh'] & PointerProps) => {

    const crossSize = 0.05;
    const {color = "red"} = props;

    return (
        <>
            <Line startLine={[0, 0, -crossSize]} endLine={[0, 0, crossSize]} color={color} />
            <Line startLine={[0, -crossSize, 0]} endLine={[0, crossSize, 0]} color={color} />
            <Line startLine={[-crossSize, 0, 0]} endLine={[crossSize, 0, 0]} color={color} />
        </>
    )
};